import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_PAYMENT_RESET = 'PUT_ROUTE_PAYMENT_RESET';
export const PUT_ROUTE_PAYMENT_LOADING = 'PUT_ROUTE_PAYMENT_LOADING';
export const PUT_ROUTE_PAYMENT_SUCCESS = 'PUT_ROUTE_PAYMENT_SUCCESS';
export const PUT_ROUTE_PAYMENT_REJECT = 'PUT_ROUTE_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const putRoutePaymentReset = () => ({ type: PUT_ROUTE_PAYMENT_RESET });
export const putRoutePaymentLoading = () => ({ type: PUT_ROUTE_PAYMENT_LOADING });
export const putRoutePaymentSuccess = (payload) => ({ type: PUT_ROUTE_PAYMENT_SUCCESS, payload });
export const putRoutePaymentReject = (payload) => ({ type: PUT_ROUTE_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRoutePaymentRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Route/web/UpdateRouteBilling`, options);
};
